import React from "react"
import { CategoryIcons } from "./CategoryIcons"
import Animate, { AnimationTypes } from "../Animate/Animate"
import { useTranslation } from "react-i18next"
import type { InteractionDescriptionProps } from "../InteractionTooltip/InteractionTooltip"

interface IconSelectorProps extends InteractionDescriptionProps {
  value: string
  disable?: boolean
  onChange: (icon: string) => void
}

export const IconSelector: React.FC<IconSelectorProps> = ({ value, onChange, disable = false, descriptionKey }) => {
  const { t } = useTranslation("interactionDescriptions")

  return (
    <Animate type={AnimationTypes.slideUpIn} duration="1s">
      <div className="w-full flex flex-row gap-1">
        <div className="flex items-center justify-center w-40 h-40 rounded-[0.5rem] bg-gradient-to-br from-orange-100 to-orange-50 border border-orange-200 shadow-inner">
          <span className="text-5xl md:text-6xl transition-all duration-200">{value}</span>
        </div>

        <div className="flex-1 max-h-40 overflow-y-auto p-2 rounded-[0.5rem] bg-gray-50 border border-gray-200 shadow-inner">
          <div className="grid grid-cols-4 md:grid-cols-7 gap-3">
            {CategoryIcons.map((icon, index) => (
              <button
                data-interaction-description-key={descriptionKey}
                aria-label={descriptionKey ? `${t(descriptionKey)} ${icon}` : icon}
                key={index}
                type="button"
                disabled={disable}
                onClick={() => onChange(icon)}
                className={`
                text-2xl
                p- sm:p-3
                rounded-[0.5rem]
                transition-all duration-150
                ${
                  value === icon
                    ? "bg-orange-100 ring-2 ring-orange-400 scale-110 shadow-md"
                    : "hover:bg-white hover:shadow-sm active:scale-95"
                }
              `}
              >
                {icon}
              </button>
            ))}
          </div>
        </div>
      </div>
    </Animate>
  )
}
